import * as React from 'react';
import styles from './index.less';
import ImageDetailModalStore from './store';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import Link from '@src/components/link';

const ImageDetailModal = ({ store, onClose }) => {
  store.use();
  if (onClose) {
    store.onClose = onClose;
  }

  return (
    <ModalContainer modalState={store.isOpen}>
      <div
        className={styles.ImageDetailModalRoot}
        onClick={() => {
          // store.onClickClose();
          // onClose();
        }}
      >
        <div className={styles.imagePanel}>
          <Link
            className={styles.closeBtn}
            onClick={() => {
              store.onClickClose();
              onClose();
            }}
          />
          {/* <div className={styles.downBtn}>点击右键保存壁纸</div> */}
          <img id={'expand-img'} src={store.imageDetailUrl} alt={''} />
        </div>
      </div>
    </ModalContainer>
  );
};

export default wrapStore(ImageDetailModal, ImageDetailModalStore);
